import {
  ThemeActionTypes,
  IFetchThemesSuccessResponseBody,
} from './types'

export const fetchThemes = () => ({
  type: ThemeActionTypes.FETCH_THEMES,
})

export const fetchThemesSuccess = (payload: IFetchThemesSuccessResponseBody) => ({
  type: ThemeActionTypes.FETCH_THEMES_SUCCESS,
  payload,
})

export const fetchThemesFailure = () => ({
  type: ThemeActionTypes.FETCH_THEMES_FAILURE,
})
